import {createSelector} from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';

import {authSelector} from 'store/selectors';

export const tokenSelector = createSelector(
  authSelector,
  (auth) => auth.token
);

interface TokenInfo {
  iat: number,
  exp: number,
  id: number,
  email: string,
  name?: string,
  roles: string[],
}

export const tokenInfoSelector = createSelector(
  tokenSelector,
  (token): TokenInfo | undefined => {
    if (!token) return undefined;
    return jwtDecode(token);
  }
)
